import { SearchIcon } from "lucide-react";
import { ComponentProps, forwardRef } from "react";

import Center from "@/components/elements/layout/Center";
import classNames from "@/helpers/classNames";
import cn from "@/helpers/classNames";

import { useConnectorsContext } from "../ConnectorsProvider";

export const SearchFilter = forwardRef<
  HTMLInputElement,
  ComponentProps<"input">
>((props, ref) => {
  const { searchText, setSearchText } = useConnectorsContext();
  return (
    <div className={classNames("relative", props.className)}>
      <input
        type="text"
        ref={ref}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search connectors..."
        {...props}
        className={cn(
          "h-10 w-full rounded-xs border border-gray-200 pr-2 pl-10 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-hidden dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200",
          props.className,
        )}
      />
      <Center className="absolute top-0 left-0 h-full w-10">
        <SearchIcon className="h-4 text-gray-500" />
      </Center>
    </div>
  );
});
